import { DateValueFilterModel } from '@ag-table-lib/filter.model'
import { PaginationMetaData } from '@shared-util-lib/table/pagination.model'
import { SortOrder } from '@shared-util-lib/table/table.model'

export interface IdleTimesTableFilters {
    wagonNumber?: string
    city?: string
    cities?: string[]
    idleTimes?: Array<string>
    productKeys?: string[]
    periodFrom?: string
    periodTo?: string
}

export interface IdleTimesRequest {
    filters: IdleTimesTableFilters
    order: SortOrder
    orderBy: IdleTimesColumnId
    pageNumber: number
    pageSize: number
}

export enum CompletionStatus {
    ONGOING = 'ONGOING',
    INACTIVE_CONNECTOR = 'INACTIVE_CONNECTOR',
    COMPLETED = 'COMPLETED',
}

export interface IdleWagon {
    wagonId: string
    wagonNumber: string
    dataOwner?: string
    uicClass?: string
    contractedProduct?: string
    contractedSegment?: string
    connectLastUpdatedAt?: string
    completionStatus?: CompletionStatus
    currentlyContracted?: boolean
    cappedIdleTimeStartedAt?: string
    cappedIdleTimeEndedAt?: string
    cappedTotalIdleMinutes?: number
    uncappedIdleTimeStartedAt?: string
    uncappedIdleTimeEndedAt?: string
    uncappedTotalIdleMinutes?: number
    location?: {
        city?: string
        country?: string
    }
}

export interface IdleTimesMetaData extends PaginationMetaData {
    totalIdleTimeCount: number
    totalWagonCount: number
}

export enum IdleTimesEmptyResultReason {
    NO_CONNECT_SERVICE = 'NO_CONNECT_SERVICE',
    NOTHING_FOUND = 'NOTHING_FOUND',
}

export interface IdleTimesResponse {
    wagons: IdleWagon[]
    pageMetaData: IdleTimesMetaData
    emptyResultReason?: IdleTimesEmptyResultReason
}

export interface IdleTimesLocationsResponse {
    locations: IdleTimesLocation[]
}

export interface IdleTimesLocation {
    country: string
    cities: string[]
}

export interface IdleTimesIntervalsResponse {
    intervals: IdleTimesInterval[]
}

export interface IdleTimesInterval {
    intervalId: string
    description: string
}

export interface IdleTimesLoadsResponse {
    loads: IdleTimesLoad[]
}

export interface IdleTimesLoad {
    segment: string
    products: IdleTimesProduct[]
}

export interface IdleTimesProduct {
    key: string
    description: string
}

export enum IdleTimesColumnId {
    WAGON_NUMBER = 'WAGON_NUMBER',
    CURRENT_LOCATION = 'CURRENT_LOCATION',
    PERIOD_FROM = 'PERIOD_FROM',
    PERIOD_TO = 'PERIOD_TO',
    CURRENT_IDLE_MINUTES = 'CURRENT_IDLE_MINUTES',
    UIC_CLASS = 'UIC_CLASS',
    CONTRACTED_PRODUCT = 'CONTRACTED_PRODUCT',
}

export interface IdleTimesTableFilterModel {
    [IdleTimesColumnId.PERIOD_FROM]?: DateValueFilterModel[]
    [IdleTimesColumnId.PERIOD_TO]?: DateValueFilterModel[]
}
